import { NavigationBarActions } from '../../constants';

export const updateTheme = (darkToggle) => ({
  type: NavigationBarActions.UPDATE_THEME,
  payload: darkToggle,
});

export const loadTheme = () => ({
  type: NavigationBarActions.ON_LOAD_THEME,
});

export const saveTheme = (darkToggle) => ({
  type: NavigationBarActions.SAVE_THEME,
  darkToggle,
});
